export const IS_USER_LOGGED_IN = 'IS_USER_LOGGED_IN'
export const REMEMBER_ME = 'REMEMBER_ME'
export const USER_LOGOUT = 'USER_LOGOUT'

/** USERREDUCER */
export const USER_INFO = 'USER_INFO'
